<template>
  <div class="container-fluid" style="padding:0;">
    <tab></tab>
    <div class="row">
      <div class="activity-top" :class="{'hidden-xs hidden-sm':isShowWeb}">
        <img src="@/images/dynamic.png" alt="#" class="inner-item-img"/>
        <div class="activity-top-font">
          <div class="top-font-font">{{lanType==1?'出版物':'Publications'}}</div>
        </div>
      </div>

      <div class="phone-activity-top hidden-md hidden-lg" v-if="isShowWeb">
        <img src="@/images/dynamic.png" alt="#" class="phone-inner-img"/>
        <div class="activity-top-font">
          <div class="phone-font-font">{{lanType==1?'出版物':'Publications'}}</div>
        </div>
      </div>
    </div>

    <!-- <div class="row">
      <div class="dynamic-top middle" :class="{'hidden-xs hidden-sm':isShowWeb}">
        <div class="dynamic-top-list color1 border1" :class="{'choiceBg1':projectId==0}" @click="choiceProjectId(0)">{{lanType==1?'全部出版物':'All publications'}}</div>
        <div class="dynamic-top-list color2 border2" :class="{'choiceBg2':projectId==1}" @click="choiceProjectId(1)">{{lanType==1?'SBTi科学碳目标':'Science Based Target initiative (SBTi)'}}</div>
        <div class="dynamic-top-list color3 border3" :class="{'choiceBg3':projectId==2}" @click="choiceProjectId(2)">{{lanType==1?'绿色电力需求倡议':"Renewable Energy Buyers' Principles"}}</div>
        <div class="dynamic-top-list color4 border4" :class="{'choiceBg4':projectId==3}" @click="choiceProjectId(3)">{{lanType==1?'气候创行者':'Climate Solver'}}</div>
        <div class="dynamic-top-list color5 border5" :class="{'choiceBg5':projectId==4}" @click="choiceProjectId(4)">{{lanType==1?'可持续燃料':'Sustainable Fuels'}}</div>
      </div>

      <div class="dynamic-top hidden-md hidden-lg middle spaceBetween" v-if="isShowWeb" style="flex-wrap: wrap;">
        <div class="phone-dynamic-top middle color1 border1" :class="{'choiceBg1':projectId==0}"  @click="choiceProjectId(0)">{{lanType==1?'全部出版物':'All publications'}}</div>
        <div class="phone-dynamic-top middle color2 border2" :class="{'choiceBg2':projectId==1}"  @click="choiceProjectId(1)">{{lanType==1?'SBTi科学碳目标':'Science Based Target initiative (SBTi)'}}</div>
        <div class="phone-dynamic-top middle color3 border3" :class="{'choiceBg3':projectId==2}"  @click="choiceProjectId(2)">{{lanType==1?'绿色电力需求倡议':"Renewable Energy Buyers' Principles"}}</div>
        <div class="phone-dynamic-top middle color4 border4" :class="{'choiceBg4':projectId==3}"  @click="choiceProjectId(3)">{{lanType==1?'气候创行者':'Climate Solver'}}</div>
        <div class="phone-dynamic-top middle color5 border5" :class="{'choiceBg5':projectId==4}"  @click="choiceProjectId(4)">{{lanType==1?'可持续燃料':'Sustainable Fuels'}}</div>
      </div>
    </div> -->

    <div class="row" :class="{'hidden-xs hidden-sm':isShowWeb}">
      <div class="dynamic-center spaceBetween wrap">
        <div class="img-info-list" @click="goMechanism(item)" v-for="(item,index) in pageList" :key="index">
          <div class="info-list-top">
            <img :src='item.picStr' alt="#" class="list-top-img"/>
            <div class="info-list-layer">
              <div class="list-layer-li" v-if="item.title_sub">{{lanType==1?item.title_sub:item.title_subEn}}</div>
              <div class="list-layer-li" v-if="item.title_sup">{{lanType==1?item.title_sup:item.title_supEn}}</div>
            </div>
          </div>
          <div class="info-list-middle">
            <div class="list-middle-title">{{lanType==1?item.title:item.titleEn}}</div>
            <div class="list-middle-center">{{lanType==1?item.brief:item.briefEn}}</div>
            <div class="top-bottom-bottom spaceBetween">
              <div class="bottom-bottom-left ">{{item.release_date}}</div>
              <div class="bottom-bottom-left color1">{{lanType==1?'查看详情':'View details'}}</div>
            </div>
          </div>
        </div>

        <!-- <div class="img-info-list" @click="goMechanism">
          <div class="info-list-top">
            <img src='@/images/banner.jpg' alt="#" class="list-top-img"/>
            <div class="info-list-layer">
              <div class="list-layer-li">SBTi科学碳目标</div>
            </div>
          </div>
          <div class="info-list-middle">
            <div class="list-middle-title">“绿色电力消费能力提升”研讨会召开</div>
            <div class="list-middle-center">2019年8月27日，作为中国新能源电力圆桌系列活动，“绿色电力消费能力提升”研讨会在北京召开。研讨会由《能源》杂志、中国新能源电力圆桌等主办，世界自然基金会（WWF）等机构和企业参与。来自新能源运营商、电力用户、综合能源......</div>
            <div class="top-bottom-bottom spaceBetween">
              <div class="bottom-bottom-left ">2020-11-24</div>
              <div class="bottom-bottom-left color1">查看详情</div>
            </div>
          </div>
        </div> -->
      </div>
      <div class="dynamic-paging middle" v-if="totalList&&totalList.length>0">
        <div class="dynamic-paging-btn dynamic-paging-up middle" @click="upPage">{{lanType==1?'上一页':'UP'}}</div>
        <ul class="middle"  v-for="(item,index) in totalList" :key="index" v-if="totalIndex==index">
          <li class="dynamic-paging-list middle" :class="{'bg1':page==res}" v-for="(res,index) in item" :key="index" @click="choicePage(res)">{{res}}</li>
          <!-- <li class="dynamic-paging-list middle" @click="choicePage(index+1)">2</li>
          <li class="dynamic-paging-list middle" @click="choicePage(index+1)">3</li> -->
        </ul>
        <div class="dynamic-paging-btn dynamic-paging-down middle" @click="downPage">{{lanType==1?'下一页':'DOWN'}}</div>
      </div>
    </div>

    <div class="row hidden-md hidden-lg" v-if="isShowWeb">
      <div class="phone-dynamic-center">
        <div class="img-info-list phone-info-list" @click="goMechanism(item)" v-for="(item,index) in pageList" :key="index">
          <div class="info-list-top phone-list-top">
            <img :src='item.picStr' alt="#" class="list-top-img"/>
            <div class="info-list-layer">
              <div class="list-layer-li" v-if="item.title_sub">{{lanType==1?item.title_sub:item.title_subEn}}</div>
              <div class="list-layer-li" v-if="item.title_sup">{{lanType==1?item.title_sup:item.title_supEn}}</div>
            </div>
          </div>
          <div class="info-list-middle phone-list-middle">
            <div class="phone-list-title">{{lanType==1?item.title:item.titleEn}}</div>
            <div class="phone-list-center">{{lanType==1?item.brief:item.briefEn}}</div>
            <div class="top-bottom-bottom spaceBetween">
              <div class="bottom-bottom-left-phone">{{item.release_date}}</div>
              <div class="bottom-bottom-left-phone color1">{{lanType==1?'查看详情':'View details'}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="phone-legs-btn middle" @click="moreBtn">{{lanType==1?'加载更多':'Load more'}}</div>
    </div>


    <footerBar ref="footerView"></footerBar>
  </div>
</template>

<script>
import tab from '@/components/tab';
import footerBar from '@/components/footerBar';
import axios from 'axios';
import { chunkArr } from '@/utils/util';
import config from '@/utils/config';
export default {
  name: 'activity',
  components: {
    tab:tab,
    footerBar:footerBar
  },
  data () {
    return {
      page:1,
      per_page:9,
      pageList:[],
      total:0,
      totalList:[],
      totalIndex:0,
      totalFor:[],
      projectId:0,
      isShowWeb:config.urlList.isShowWeb,
      lanType:1
    }
  },
  methods:{
    fatherMethod(type){
      const vm=this
      vm.lanType=type
      setTimeout(()=>{
        vm.$refs.footerView.choiceType(type);
      },400)
    },
    choiceProjectId(num){
      const vm=this
      vm.projectId=num;
      vm.page=1;
      vm.per_page=9;
      vm.queryCampaign();
    },
    queryCampaign(){
      const vm=this
      axios.post(
        `${config.urlList.queryUrl}/api/cbh/news_list`,
        {
          type:2,
          is_recommend:0,
          project_id:vm.projectId,
          page:vm.page,
          per_page:vm.per_page
        },
      ).then(res => {
        if(res.data.code==1){
          let arr=[];
          res.data.data.data.forEach(da=>{

            da.title_subEn = da.title_subEn?da.title_subEn:da.title_sub
            da.title_supEn = da.title_supEn?da.title_supEn:da.title_sup
            da.titleEn = da.titleEn?da.titleEn:da.title
            da.briefEn = da.briefEn?da.briefEn:da.brief
            da.picStr=`${config.urlList.imgUrl}${da.pic}`;
          })
          vm.pageList=res.data.data.data
          vm.current_page=res.data.data.last_page
          vm.total=res.data.data.last_page
          //vm.total=100
          //chunkArr
          for(var i=0;i<vm.total;i++){
            arr.push(i+1);
          }
          vm.totalList=chunkArr(arr,10)
          vm.totalFor=vm.totalList[vm.totalIndex]
        }else{
          vm.pageList=[]
        }
      })
    },
    choicePage(num){
      const vm=this
      vm.page=num;
      vm.queryCampaign();
    },
    upPage(){
      const vm=this;
      if(vm.totalIndex>0){
        vm.totalIndex--
      }
    },
    downPage(){
      const vm=this;
      if(vm.totalIndex<vm.totalList.length-1){
        vm.totalIndex++
      }
      //vm.queryCampaign();
    },
    moreBtn(){
      const vm=this
      if(vm.total>vm.per_page){
        vm.per_page+=9;
        vm.queryCampaign()
      }
    },
    goMechanism(item){
      const vm=this
      vm.$router.push({ path:'/mechanism',query:{id:item.id,type:2}})
    }
  },
  created () {
    const vm = this;
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  },
  mounted(){
    const vm=this
    vm.projectId = vm.$route.query.type || 1
    vm.queryCampaign()
  }
}
</script>
<style scoped>
/**  pc banner图  **/
.activity-top{
  width: 100%;
  height: 2.20625rem;
  position: relative;
}
.inner-item-img{
  width: 100%;
  height: 100%;
}
.activity-top-font{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.top-font-font{
  font-size: 0.45rem;
  color: #fff;
  font-family: 'wwf';
}
/**  web Banner图  **/
.phone-activity-top{
  width: 100%;
  height: 8rem;
  position: relative;
}
.phone-inner-img{
  width: 100%;
  height: 100%;
}
.phone-font-font{
  font-size: 0.8rem;
  color: #fff;
}

/**  pc  **/
.dynamic-top{
  padding: 0.5rem;
  height: auto;
}
.dynamic-top-list{
  min-width: 1.1875rem;
  width: auto;
  padding: 0 20px;
  height: 0.325rem;
  text-align: center;
  line-height: 0.325rem;
  margin-right: 0.2rem;
  cursor: pointer;
  border-radius: 6px;
}

/**  web  **/
.phone-dynamic-top{
  min-width: 4rem;
  width: auto;
  padding: 0 20px;
  height: 0.8rem;
  font-size: 0.32rem;
  text-align: center;
  line-height: 0.8rem;
  margin: 0 auto 0.2rem;
}

/**  最新动态  **/
.dynamic-center{
  padding: 0.5rem;
}
.web-index-neck{
  font-size: 0.375rem;
  color: #000000;
  margin-top: 0.425rem;
  line-height: 1.6;
  position: relative;
}
.web-index-neck::before{
  content: "";
  display: block;
  width: 0.75rem;
  height: 4px;
  background: #cf6e32;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}
.web-neck-center{
  margin: 0.3125rem 0.5rem 0;
  height: auto;
}
.img-info-list{
  width: 32%;
  height: auto;
  -webkit-box-shadow: #d1d1d1 0px 0px 10px; 
  -moz-box-shadow: #d1d1d1 0px 0px 10px; 
  box-shadow: #d1d1d1 0px 0px 10px;
  margin: 0 4px 0.3rem;
  cursor: pointer;
}
.info-list-top{
  width: 100%;
  height: 1.625rem;
  position: relative;
}
.list-top-img{
  width: 100%;
  height: 100%;
  border-radius: 4px 4px 0 0;
}
.info-list-middle{
  padding: 0.2rem 0.25rem;
  background: #fff;
  border-radius: 0 0 4px 4px;
  box-shadow: 0px 2px 4px #d1d1d1;
}
.list-middle-tips{
  font-size: 0.1125rem;
  color: #cf6e32;
  font-style: italic;
  text-align: left;
}
.list-middle-title{
  font-size: 0.15rem;
  color: #000;
  line-height: 1.4;
  height: 0.42rem;
  margin-bottom: 0.1rem;
  overflow : hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  text-align: left;
  font-family: 'wwf';
}
.list-middle-center{
  font-size: 0.1rem;
  color: #333333;
  line-height: 1.4;
  height: 0.56rem;
  overflow : hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-clamp: 4;
  -webkit-box-orient: vertical;
  text-align: left;
}
.info-list-layer{
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
}
.list-layer-li{
  margin-bottom: 0.125rem;
  padding: 6px 10px;
  font-size: 0.0875rem;
  color: #fff;
  background: #32a5cf;
  margin-right: 0.0625rem;
  display: inline-block;
}
.list-layer-li:nth-child(1){
  margin-left: 0.25rem;
}
.neck-indicators{
  position: absolute;
  bottom: 0 !important;
}
.neck-indicators li{
  background: #aaaaaa !important;
}
.glyphicon-chevron-left,.glyphicon-chevron-right{
  margin: 0 !important;
  color: #000;
  text-shadow: none;
  font-size: 18px;
}
.neck-btn-left{
  width: 0.4375rem;
  height: 0.4375rem;
  background: #fff;
  border-radius: 50%;
  box-shadow: 2px 2px 4px #c9c9c9;
  position: absolute;
  top: 50%;
  left: -0.21875rem;
  transform: translateY(-50%);
}
.neck-btn-right{
  width: 0.4375rem;
  height: 0.4375rem;
  background: #fff;
  border-radius: 50%;
  box-shadow: 2px 2px 4px #c9c9c9;
  position: absolute;
  top: 50%;
  right: -0.21875rem;
  transform: translateY(-50%);
}
.dynamic-paging{
  margin-top: 0.325rem;
  padding: 0 0.5rem;
}
.dynamic-paging-btn{
  width: 1.25rem;
  height: 0.375rem;
  background: #eeeeee;
  font-size: 0.15rem;
  color: #49bc9b;
  font-weight: 600;
  margin: 0 0.125rem;
  cursor: pointer;
}
.dynamic-paging-list{
  width: 0.375rem;
  height: 0.375rem;
  background: #eeeeee;
  font-size: 0.15rem;
  color: #49bc9b;
  font-weight: 600;
  margin: 0 0.125rem;
  margin-bottom: 0;
  cursor: pointer;
}
.bg1{
  background: #49bc9b;
  color: #fff;
}
.top-bottom-bottom{
  margin-top: 0.125rem;
  width: 100%;
  cursor: pointer;
}
.bottom-bottom-left{
  font-size: 0.1125rem;
    color: #999;
}

.color1{
  color: #49bc9b;
}

/**  web最新动态  **/
.phone-index-neck{
  font-size: 0.72rem;
  font-weight: 500;
  color: #000000;
  margin-top: 0.906rem;
  line-height: 2;
  position: relative;
}
.phone-index-neck::before{
  content: "";
  display: block;
  width: 1.44rem;
  height: 4px;
  background: #cf6e32;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}
.phone-info-list{
  width: 100%;
  margin-bottom: 1.1rem;
  margin-left: 0;
}
.phone-list-top{
  height: 5rem;
  width: 100%;
}
.phone-list-middle{
  padding: 0.4rem 0.88rem 0.74rem;
}
.phone-list-tips{
  font-size: 0.32rem;
  font-weight: 500;
}
.phone-list-title{
  font-size: 0.48rem;
  color: #000;
  font-family: 'wwf';
  line-height: 1.4;
  margin-bottom: 0.32rem;
  text-align: left;
}
.phone-list-center{
  font-size: 0.32rem;
  color: #000;
  line-height: 1.4;
  text-align: left;
}
.phone-dynamic-center{
  padding: 0.5rem;
}
.phone-legs-btn{
  width: 4rem;
  height: 1.067rem;
  background: #49bc9b;
  font-size: 0.4rem;
  color: #fff;
  margin: 0 auto 0.5rem;
}
.bottom-bottom-left-phone{
  font-size: 0.325rem;
  color: #999;
}

.color1{
  color: #32a5cf;
}
.color2{
  color: #436aba;
}
.color3{
  color: #ed9534;
}
.color4{
  color: #49bc9b;
}
.color5{
  color: #0286e3;
}
.border1{
  border:1px solid #32a5cf;
}
.border2{
  border:1px solid #436aba;
}
.border3{
  border:1px solid #ed9534;
}
.border4{
  border:1px solid #49bc9b;
}
.border5{
  border:1px solid #0286e3;
}
.choiceBg1{
  background: #32a5cf;
  color: #fff;
}
.choiceBg2{
  background: #436aba;
  color: #fff;
}
.choiceBg3{
  background: #ed9534;
  color: #fff;
}
.choiceBg4{
  background: #49bc9b;
  color: #fff;
}
.choiceBg5{
  background: #0286e3;
  color: #fff;
}
</style>

